import React from 'react'
import MenuItem from '@material-ui/core/MenuItem'

import Button from 'components/CustomButtons/Button'
// nodejs library to set properties for components

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'

// material-ui icons
import MoreVert from '@material-ui/icons/MoreVert'
import { unwrapResult } from '@reduxjs/toolkit'
import styles from 'assets/jss/material-dashboard-pro-react/components/adminNavbarStyle.js'
import buttonStyles from 'assets/jss/material-dashboard-pro-react/components/buttonStyle.js'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'

import ListItemText from '@material-ui/core/ListItemText'
import Menu from '@material-ui/core/Menu'
import { withStyles } from '@material-ui/core/styles'
import { notification } from 'antd'
import {
  deleteAssessmentMethodQuestions,
  fetchAssessmentQuestionsMethods,
  deleteMappingAssessmentMethod,
} from 'reduxToolkit/features/assessmentMethod/AssessmentMethodsSlice'
import AddQuestionAssessmentModal from 'views/Components/AddQuestionAssessmentModal'
import EditQuestionAssessmentModal from 'views/Components/EditQuestionAssessmentModal'
// import EditAssessmentMethodInstructors from '../Pages/Assessments/courseAssessments/AssessmentMethodInstructors.js'
import ErrorModal from '../../../../views/Components/ErrorModal.jsx'
import SuperGeneralDeleteModal from '../../../Components/SuperGeneralDeleteModal'
import { fetchAssessmentMethodsNotGenerated } from 'reduxToolkit/features/assessmentMethod/SliceAssessmentMethodSliceSpec'
const useStyles = makeStyles(styles)
const useButtonStyles = makeStyles(buttonStyles)

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))
const DropDownAssessment = ({
  selectedRowData,
  disabled,
  selectedRows,
  assessmentQuestionsMethod_name,
  assessmentMethod_id,
  course_id,
  disabledDelete,
  programId,
  exportData,
}) => {
  const { t } = useTranslation()
  const buttonClasses = useButtonStyles()
  const [open, setOpen] = React.useState(false)
  const [openAssessmentQuestions, setOpenAssessmentQuestions] = React.useState(
    false,
  )
  const anchorRef = React.useRef(null)
  const [selectedIndex, setSelectedIndex] = React.useState(1)

  const dispatch = useDispatch()

  const classes = useStyles()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleOpenDeleteModal = () => {
    setOpen(true)
  }

  const handleCloseDeleteModal = () => {
    setOpen(false)
  }
  const handleCloseDeleteAssessmentQuestionsModal = () => {
    setOpenAssessmentQuestions(false)
  }
  const handleOpenDeleteAssessmentQuestionsModal = () => {
    setOpenAssessmentQuestions(true)
  }

  const handleOpenDeleteAssessmentMethodModal = () => {
    setOpen(true)
  }

  const handleCloseDeleteAssessmentMethodModal = () => {
    setOpen(false)
  }
  const [openErrorModal, setOpenErrorModal] = React.useState(false)
  const [handledError, setHandledError] = React.useState('')
  const [anchorEl, setAnchorEl] = React.useState(null)
  const handleOpenErrorModal = () => {
    setOpenErrorModal(true)
  }
  const handleCloseErrorModal = () => {
    setOpenErrorModal(false)
  }
  const handleDeleteItem = async () => {
    console.log(selectedRows)
    // console.log('id handleDeleteAssessmentMethodQuestionsSelected',props.selectedRows)
    // console.log('id handleDeleteAssessmentMethod ID',props.assessmentMethod_id)

    try {
      const resultAction = await dispatch(
        deleteAssessmentMethodQuestions({ questions_delete_ids: selectedRows }),
      )
      unwrapResult(resultAction)
      handleClose()
      openNotificationWithIcon('success', `Deleted`)
      dispatch(fetchAssessmentQuestionsMethods(course_id))
    } catch (err) {
      setHandledError(err)
      handleOpenErrorModal()
    }
  }

  // const handleDeleteAssessmentMethod = async () => {
  //   let obj = {
  //     assessmentMethod_id: props.assessmentMethod_id,
  //     course_id: props.course_id,
  //     clo_id: props.clo_id,
  //   }
  //   console.log('id handleDeleteAssessmentMethod', props.assessmentMethod_id)
  //   try {
  //     const resultAction = await dispatch(deleteMappingAssessmentMethod(obj))
  //     unwrapResult(resultAction)
  //     handleClose()
  //     dispatch(fetchAssessmentMethodsNotGenerated(props.course_id))
  //     openNotificationWithIcon('success', `Deleted`)
  //     dispatch(fetchAssessmentQuestionsMethods(props.course_id))
  //   } catch (err) {
  //     setHandledError(err)
  //     handleOpenErrorModal()
  //   }
  // }
  const openNotificationWithIcon = (type, msg) => {
    notification[type]({
      message: type,
      description: msg,
      top: 50,
      duration: 2,
    })
  }

  return (
    <div>
      <Button
        aria-controls="customized-menu"
        variant="contained"
        color="primary"
        onClick={handleClick}
        justIcon
        round
        aria-haspopup="true"
      >
        <MoreVert />
      </Button>

      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <Link
          to={{
            pathname: `/citrine/faculty/assessmentsQuestionsDetails/course/${course_id}/assessmentMethod/${assessmentMethod_id}/${assessmentQuestionsMethod_name}`,
          }}
        >
          <MenuItem>{t('Open')}</MenuItem>
        </Link>

        <AddQuestionAssessmentModal
          course_id={course_id}
          assessmentMethod_id={assessmentMethod_id}
          handleCloseAnchor={handleClose}
        />

        <EditQuestionAssessmentModal
          course_id={course_id}
          assessmentMethod_id={assessmentMethod_id}
          disabled={disabled}
          selectedRowData={selectedRowData}
          handleCloseAnchor={handleClose}
        />

       
        <Link
          to={{
            pathname: `/citrine/faculty/assessmentsQuestionsDetails/course/${course_id}/assessmentMethod/${assessmentMethod_id}/${assessmentQuestionsMethod_name}/Groups/`
          }}
        >
          <MenuItem>{t('Edit Groups')}</MenuItem>
        </Link>
        <MenuItem
          onClick={() => {
            handleClose()
            exportData()
          }}
          style={{ color: '#AC79B0' }}
        >
          {t('Export Data')}
        </MenuItem>

        <MenuItem
          disabled={disabledDelete}
          onClick={() => {
            handleOpenDeleteAssessmentQuestionsModal()
            handleClose()
          }}
        >
          <ListItemText primary="Delete Questions" />
        </MenuItem>

        {/* <AddQuestionAssessmentModal
          course_id={props.course_id}
          assessmentMethod_id={props.assessmentMethod_id}
          handleCloseAnchor={handleClose}
        />
        <EditQuestionAssessmentModal
          course_id={props.course_id}
          assessmentMethod_id={props.assessmentMethod_id}
          disabled={props.disabled}
          selectedRowData={props.selectedRowData}
          handleCloseAnchor={handleClose}
        /> */}

        {/* <EditAssessmentMethodInstructors
          course_id={props.course_id}
          assessmentMethod_id={props.assessmentMethod_id}
          assessmentQuestionsMethod_name={props.assessmentQuestionsMethod_name}
          selectedRowData={props.selectedRowData}
          handleCloseAnchor={handleClose}

        /> */}
        {/* <MenuItem><ListItemText primary="Delete Questions" /></MenuItem>
        <MenuItem>{t('Export Data')}</MenuItem> */}
      </StyledMenu>
      <ErrorModal
        open={openErrorModal}
        handleClose={handleCloseErrorModal}
        handledError={handledError}
      />
      <SuperGeneralDeleteModal
        delete_Element={handleDeleteItem}
        //Element_ID={id}
        open={openAssessmentQuestions}
        handleClose={handleCloseDeleteAssessmentQuestionsModal}
      />
    </div>
  )
}

export default DropDownAssessment
